<ng-container>
  @for (menuItem of contextMenuItems; track menuItem; let i = $index) {
    <div
      class="menu-link"
      (click)="onContextMenuClick($event, menuItem.menuEvent)">
      {{ menuItem.menuText }}
      @if (i < contextMenuItems.length - 1) {
        <hr />
      }
    </div>
  }
</ng-container>